module.exports = __webpack_public_path__ + "img/300x300_no_image_placeholder.f8945b65.svg";